export const AUTH_SESSIONS_ROUTES = {
    __ROOT__: '/authSessions',
}
